var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebcam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fcfcfd;stroke:#e6e8ec;stroke-miterlimit:10;}.b{fill:#353945;stroke:#353945;stroke-width:0.5px;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -36.322002, 3.28036)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.634,7.317a7.312,7.312,0,1,0-10.7,6.49,4.555,4.555,0,0,0-1.208,3.107v.51h9.189v-.51A4.555,4.555,0,0,0,51.7,13.807a7.335,7.335,0,0,0,3.931-6.49ZM51.854,16.4H44.779a3.538,3.538,0,0,1,1.165-2.162,7.377,7.377,0,0,0,4.746,0A3.538,3.538,0,0,1,51.854,16.4Zm-3.538-2.791a6.3,6.3,0,1,1,6.3-6.3A6.3,6.3,0,0,1,48.317,13.613Z",
    transform: "translate(-41 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.764 4.764)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M183.552,140a2.552,2.552,0,1,0,2.552,2.552A2.555,2.555,0,0,0,183.552,140Zm0,4.084a1.531,1.531,0,1,1,1.531-1.531A1.533,1.533,0,0,1,183.552,144.084Z",
    transform: "translate(-181 -140)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.552 3.489)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.749,
    cy: 0.749,
    r: 0.749,
    transform: "translate(0)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcam);
export default __webpack_public_path__ + "static/media/webcam.4c46441a376754ac9aee0febe44c2e49.svg";
export { ForwardRef as ReactComponent };